import { createContext } from 'react';

const ACTION_TYPE = {
  UPDATE: 1,
};

const RouterContext = createContext([]);

const routerInitialState = {
  contentList: [],
  curPath: '',
};
function routerReducer(oldState, action) {
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPE.UPDATE:
      return {
        ...oldState,
        ...payload,
      };
    default:
      return { ...oldState };
  }
}

export { RouterContext, ACTION_TYPE, routerReducer, routerInitialState };
